__turbopack_context__.v({
  "className": "poppins_9e1c1d24-module__xx9w4G__className",
});
